import { useState, useEffect } from "react";
import WatchButtonComponent from "./WatchButtonComp";

const WatchList = () => {
    const [watchList, setwatchList] = useState([]);
    const [show, setShow] = useState("");
    const wList = localStorage.getItem('watchlist');
    
    const toggleMenu = () => {
        const showClass = show === "" ? "visible " : "";
        setShow(showClass);
    }

    const getImageUrl = (url) => {
        let name = url.split('/').pop();
        return '/callgrimages/' + name;
    }

    const addDefaultSrc = (e) =>{
        return e.target.src = '/img/no-image.png'
    }

    useEffect(() => {
        
        if(wList && JSON.parse(wList).length > 0) {
            setwatchList(JSON.parse(wList));
        }
        else {
            setwatchList([]);
        }
    }, [wList])

    return (
        <div className="watch-list">
            <div onClick={toggleMenu}>
                <WatchButtonComponent />
            </div>
            {watchList.length > 0 ? (
                <div className={`${show}watch-list-menu gray-bg rounded align-left`}>
                    <h3>My Watchlist</h3>
                    <ul>
                        {watchList.map((el, index) => {
                            if(el.nameOfCallGroup && el.id) {
                                return (
                                <li key={index}>
                                    <a href={`/tokens/${el.nameOfCallGroup}`}>
                                        <span>
                                            <img onError={addDefaultSrc} className="rounded" src={getImageUrl(el.cryptoGroupImage)} alt="Crypto group image" />
                                        </span>
                                        <span>{el.nameOfCallGroup}</span>
                                    </a>
                                </li>
                                )
                            }
                            else {
                                return null;
                            }
                            
                        })}
                    </ul>
                </div>        
            ) : null}
        </div>
    )
}

export default WatchList;